import React, { ComponentProps } from 'react';
import { Flex } from '@grubhubprod/gh-cookbook-react';
import { useDataTableContext } from 'src/components/DataTable/components/DataTableProvider/hooks/useDataTableContext';
import {
  Pagination,
  PaginationProps,
} from 'src/components/DataTable/components/DataTablePagination/Pagination/Pagination';

type FlexProps = ComponentProps<typeof Flex>;
export type DataTablePaginationProps = Omit<
  PaginationProps,
  'page' | 'pageSize' | 'collectionSize' | 'pageChange'
> &
  Partial<Pick<FlexProps, 'justifyContent'>>;

export const DataTablePagination: React.FC<DataTablePaginationProps> = ({
  justifyContent = 'flex-end',
  ...props
}) => {
  const { tableState, total, setPage, isLoading } = useDataTableContext();
  const { page, pageSize } = tableState;

  return (
    <Flex justifyContent={justifyContent}>
      <Pagination
        page={page}
        pageSize={pageSize}
        collectionSize={total}
        pageChange={setPage}
        disabled={isLoading}
        boundaryLinks
        {...props}
      />
    </Flex>
  );
};
